/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminCreateEmbedOptions, AdminCreateEmbedResponses } from '../../models/AdminCreateEmbed'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Upload a document
 * @summary Create Embed
 * {@link /admin/embed/upload}
 */
export function adminCreateEmbed<ThrowOnError extends boolean = true>(options: Options<AdminCreateEmbedOptions, ThrowOnError>): Promise<UnwrappedResult<AdminCreateEmbedResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/embed/upload', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminCreateEmbedResponses, ThrowOnError>>
}
